import React from 'react';
import { Arrow } from './styles';

export default ({ show }) => (
  <Arrow show={show} className="arrow">
    <span />
  </Arrow>
);
